import { NgModule } from '@angular/core';
import { ThemeModule } from '../@theme/theme.module';
import { AuthRoutingModule, routedComponents } from './auth-routing.module';
import { NbSpinnerModule, NbButtonModule } from '@nebular/theme';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { AutoLogoutService } from './auto-logout/auto-logout.service';


@NgModule({
  imports: [
    ThemeModule,
    NbSpinnerModule,
    NbButtonModule,
    AuthRoutingModule,
  ],
  declarations: [
    ...routedComponents,
  ],
  providers: [
    NgbActiveModal,
    AuthService,
    AuthGuard,
    AutoLogoutService,
  ],
})
export class AuthModule { }
